export default __webpack_public_path__ + "static/media/cloud-arrow-down-light-full.34c17b78.svg";